import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class EmissionBicyclePermissions extends BaseScenesPermissions {}

export default EmissionBicyclePermissions
